(function () {
  'use strict';

  var FT_KEY = 'rbt_ft';
  var LT_KEY = 'rbt_lt';
  var TTL_MS = 30 * 24 * 60 * 60 * 1000;
  var GA4_DEFAULT = 'G-63ZELX03L4';
  var GA4_TIMEOUT_MS = 1500;
  var CHECKOUT_GA4_TIMEOUT_MS = 500;
  var ATTACH_DEBOUNCE_MS = 2000;
  var CHECKOUT_LOADING_RESET_MS = 8000;

  var CHECKOUT_SELECTOR =
    '#gokwik-buy-now, [data-gokwik-buy-now-trigger], .gokwik-checkout button, [onclick*="onCheckoutClick"], [onclick*="onBuyNowClick"]';

  var CHECKOUT_SESSION_ID_KEY = 'rbt_checkout_session_id';
  var CHECKOUT_INIT_DEBUG = false;
  var ITEM_REFERRER_PROP = '_item_referrer';
  var ITEM_REFERRER_MAP_KEY = 'rbt_item_referrer_map_v1';

  var lastAttachAt = 0;
  var attachPromise = null;

  function getGa4MeasurementId() {
    if (window.gaTag && window.gaTag.ga4) {
      return window.gaTag.ga4;
    }
    return GA4_DEFAULT;
  }

  function parseUtms(search) {
    var params = new URLSearchParams(search || window.location.search);
    var src = (params.get('utm_source') || '').trim();
    var med = (params.get('utm_medium') || '').trim();

    if (!src && !med) {
      return null;
    }

    return {
      src: src,
      med: med,
      cmp: (params.get('utm_campaign') || '').trim(),
      id: (params.get('utm_id') || '').trim(),
      cnt: (params.get('utm_content') || '').trim(),
      trm: (params.get('utm_term') || '').trim(),
    };
  }

  function normalizeHost(hostname) {
    return (hostname || '').replace(/^www\./i, '').toLowerCase();
  }

  function isInternalReferrerHost(host) {
    if (!host) {
      return true;
    }

    if (host === normalizeHost(window.location.hostname)) {
      return true;
    }

    return (
      host === 'rabitat.com' ||
      host.endsWith('.myshopify.com') ||
      host === 'shopify.com' ||
      host.endsWith('.shopify.com') ||
      host.endsWith('.shopifycdn.com') ||
      host.endsWith('.shopifycloud.com')
    );
  }

  function parseReferrer(referrer) {
    if (!referrer) {
      return null;
    }

    try {
      var url = new URL(referrer);
      var host = normalizeHost(url.hostname);

      if (isInternalReferrerHost(host)) {
        return null;
      }

      if (/google\.|bing\.|yahoo\.|duckduckgo\.|baidu\./.test(host)) {
        var engine = host.split('.')[0];
        if (engine === 'google' || engine === 'bing' || engine === 'yahoo') {
          return {
            src: engine,
            med: 'organic',
            cmp: '',
            id: '',
            cnt: '',
            trm: '',
          };
        }
      }

      if (/facebook\.|instagram\.|fb\.com/.test(host)) {
        return {
          src: 'facebook',
          med: 'referral',
          cmp: '',
          id: '',
          cnt: '',
          trm: '',
        };
      }

      return {
        src: host,
        med: 'referral',
        cmp: '',
        id: '',
        cnt: '',
        trm: '',
      };
    } catch (error) {
      return null;
    }
  }

  function buildTouch(source) {
    if (!source) {
      return null;
    }

    return {
      src: source.src || '',
      med: source.med || '',
      cmp: source.cmp || '',
      id: source.id || '',
      cnt: source.cnt || '',
      trm: source.trm || '',
      at: new Date().toISOString(),
      landing: window.location.pathname + window.location.search,
    };
  }

  function currentTouch() {
    return buildTouch(parseUtms()) || buildTouch(parseReferrer(document.referrer));
  }

  function readTouch(key) {
    try {
      var raw = localStorage.getItem(key);
      if (!raw) {
        return null;
      }

      var parsed = JSON.parse(raw);
      if (!parsed || !parsed.at) {
        return null;
      }

      if (Date.now() - new Date(parsed.at).getTime() > TTL_MS) {
        localStorage.removeItem(key);
        return null;
      }

      return parsed;
    } catch (error) {
      return null;
    }
  }

  function writeTouch(key, touch) {
    if (!touch) {
      return;
    }

    try {
      localStorage.setItem(key, JSON.stringify(touch));
    } catch (error) {}
  }

  function captureOnLoad() {
    var touch = currentTouch();
    if (!touch) {
      return;
    }

    if (!readTouch(FT_KEY)) {
      writeTouch(FT_KEY, touch);
    }

    writeTouch(LT_KEY, touch);
  }

  function emptyFtAttrs() {
    return {
      _ft_src: '',
      _ft_med: '',
      _ft_cmp: '',
      _ft_id: '',
      _ft_cnt: '',
      _ft_trm: '',
      _ft_at: '',
    };
  }

  function emptyLtAttrs() {
    return {
      _lt_src: '',
      _lt_med: '',
      _lt_cmp: '',
      _lt_id: '',
      _lt_cnt: '',
      _lt_trm: '',
    };
  }

  function touchToFtAttrs(touch) {
    if (!touch) {
      return emptyFtAttrs();
    }

    return {
      _ft_src: touch.src || '',
      _ft_med: touch.med || '',
      _ft_cmp: touch.cmp || '',
      _ft_id: touch.id || '',
      _ft_cnt: touch.cnt || '',
      _ft_trm: touch.trm || '',
      _ft_at: touch.at || '',
    };
  }

  function touchToLtAttrs(touch) {
    if (!touch) {
      return emptyLtAttrs();
    }

    return {
      _lt_src: touch.src || '',
      _lt_med: touch.med || '',
      _lt_cmp: touch.cmp || '',
      _lt_id: touch.id || '',
      _lt_cnt: touch.cnt || '',
      _lt_trm: touch.trm || '',
    };
  }

  function readCookie(name) {
    var escaped = name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    var match = document.cookie.match(new RegExp('(?:^|; )' + escaped + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : '';
  }

  function getGaClientIdFromCookie() {
    var value = readCookie('_ga');
    if (!value) {
      return '';
    }

    var parts = value.split('.');
    if (parts.length >= 4) {
      return parts.slice(-2).join('.');
    }

    return '';
  }

  function getGaSessionIdFromCookie(measurementId) {
    var suffix = (measurementId || '').replace(/^G-/, '');
    if (!suffix) {
      return '';
    }

    var value = readCookie('_ga_' + suffix);
    if (!value) {
      return '';
    }

    var segments = value.split('$');
    for (var i = 0; i < segments.length; i++) {
      if (segments[i].charAt(0) === 's' && segments[i].length > 1) {
        return segments[i].slice(1);
      }
    }

    return '';
  }

  function getGa4IdsFromCookies(measurementId) {
    return {
      cid: getGaClientIdFromCookie(),
      sid: getGaSessionIdFromCookie(measurementId),
    };
  }

  function getGa4Ids(measurementId, timeoutMs) {
    var cookieIds = getGa4IdsFromCookies(measurementId);

    return new Promise(function (resolve) {
      var result = { cid: cookieIds.cid, sid: cookieIds.sid };
      var settled = false;

      function finish() {
        if (settled) {
          return;
        }
        settled = true;

        if (!result.cid) {
          result.cid = getGaClientIdFromCookie();
        }
        if (!result.sid) {
          result.sid = getGaSessionIdFromCookie(measurementId);
        }

        resolve(result);
      }

      if (typeof window.gtag !== 'function') {
        finish();
        return;
      }

      window.setTimeout(finish, timeoutMs || GA4_TIMEOUT_MS);

      var pending = 2;

      function markDone() {
        pending -= 1;
        if (pending <= 0) {
          finish();
        }
      }

      try {
        window.gtag('get', measurementId, 'client_id', function (clientId) {
          if (clientId) {
            result.cid = clientId;
          }
          markDone();
        });
        window.gtag('get', measurementId, 'session_id', function (sessionId) {
          if (sessionId) {
            result.sid = String(sessionId);
          }
          markDone();
        });
      } catch (error) {
        finish();
      }
    });
  }

  function postCartAttributes(attributes) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      credentials: 'same-origin',
      body: JSON.stringify({ attributes: attributes }),
    }).catch(function () {
      return null;
    });
  }

  function buildOrderAttributes(gaIds, extraAttributes) {
    var firstTouch = readTouch(FT_KEY);
    var lastTouch = readTouch(LT_KEY);

    return Object.assign(
      {
        _ga_cid: (gaIds && gaIds.cid) || '',
        _ga_sid: (gaIds && gaIds.sid) || '',
        _landing: (firstTouch && firstTouch.landing) || window.location.pathname + window.location.search,
      },
      touchToFtAttrs(firstTouch),
      touchToLtAttrs(lastTouch),
      extraAttributes || {}
    );
  }

  function rbtAttachAcquisition(options) {
    var opts = options || {};
    var timeoutMs = opts.timeoutMs || GA4_TIMEOUT_MS;
    var extraAttributes = opts.extraAttributes || null;
    var now = Date.now();

    if (!opts.force && attachPromise && now - lastAttachAt < ATTACH_DEBOUNCE_MS) {
      return attachPromise;
    }

    lastAttachAt = now;
    attachPromise = getGa4Ids(getGa4MeasurementId(), timeoutMs)
      .then(function (gaIds) {
        return postCartAttributes(buildOrderAttributes(gaIds, extraAttributes));
      })
      .catch(function () {
        return postCartAttributes(buildOrderAttributes({ cid: '', sid: '' }, extraAttributes));
      })
      .finally(function () {
        window.setTimeout(function () {
          if (Date.now() - lastAttachAt >= ATTACH_DEBOUNCE_MS) {
            attachPromise = null;
          }
        }, ATTACH_DEBOUNCE_MS);
      });

    return attachPromise;
  }

  function generateCheckoutUuid() {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
      return crypto.randomUUID();
    }

    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (char) {
      var random = (Math.random() * 16) | 0;
      var value = char === 'x' ? random : (random & 0x3) | 0x8;
      return value.toString(16);
    });
  }

  function getOrCreateCheckoutSessionId() {
    try {
      var existing = sessionStorage.getItem(CHECKOUT_SESSION_ID_KEY);
      if (existing) {
        return existing;
      }

      var sessionId = 'sess_' + generateCheckoutUuid();
      sessionStorage.setItem(CHECKOUT_SESSION_ID_KEY, sessionId);
      return sessionId;
    } catch (error) {
      return 'sess_' + generateCheckoutUuid();
    }
  }

  function createCheckoutIntentId() {
    return 'ci_' + generateCheckoutUuid();
  }

  function isCartGokwikCheckoutButton(button) {
    if (!button || !button.closest('.gokwik-checkout')) {
      return false;
    }

    return !!(button.closest('[data-cart-drawer]') || button.closest('[data-cart-page]'));
  }

  function getCheckoutInitiatedSource(button) {
    if (button.closest('[data-cart-drawer]')) {
      return 'cart_drawer';
    }

    if (button.closest('[data-cart-page]')) {
      return 'cart_page';
    }

    return '';
  }

  function getCheckoutDeviceType() {
    return window.matchMedia('(max-width: 768px)').matches ? 'mobile' : 'desktop';
  }

  function getShopDomain() {
    if (window.Shopify && window.Shopify.shop) {
      return window.Shopify.shop;
    }

    return window.location.hostname;
  }

  function getCheckoutAttributionFields() {
    var firstTouch = readTouch(FT_KEY);
    var lastTouch = readTouch(LT_KEY);

    return {
      landing_page: (firstTouch && firstTouch.landing) || window.location.pathname + window.location.search,
      utm_source: (lastTouch && lastTouch.src) || '',
      utm_medium: (lastTouch && lastTouch.med) || '',
      utm_campaign: (lastTouch && lastTouch.cmp) || '',
      utm_content: (lastTouch && lastTouch.cnt) || '',
      utm_term: (lastTouch && lastTouch.trm) || '',
    };
  }

  function getCurrentItemReferrer() {
    return window.location.href;
  }

  function rememberItemReferrer(variantId, referrer) {
    if (!variantId || !referrer) {
      return;
    }

    try {
      var map = JSON.parse(sessionStorage.getItem(ITEM_REFERRER_MAP_KEY) || '{}');
      map[String(variantId)] = referrer;
      sessionStorage.setItem(ITEM_REFERRER_MAP_KEY, JSON.stringify(map));
    } catch (error) {}
  }

  function getStoredItemReferrer(variantId) {
    if (!variantId) {
      return '';
    }

    try {
      var map = JSON.parse(sessionStorage.getItem(ITEM_REFERRER_MAP_KEY) || '{}');
      return map[String(variantId)] || '';
    } catch (error) {
      return '';
    }
  }

  function getLineItemProperty(item, key) {
    if (!item || !item.properties) {
      return '';
    }

    if (typeof item.properties === 'object' && !Array.isArray(item.properties)) {
      return item.properties[key] || '';
    }

    if (Array.isArray(item.properties)) {
      for (var i = 0; i < item.properties.length; i++) {
        var entry = item.properties[i];
        if (!entry) continue;
        if (entry.name === key || entry.key === key) {
          return entry.value || '';
        }
      }
    }

    return '';
  }

  function injectItemReferrerIntoAddPayload(data) {
    if (!data || typeof data !== 'object') {
      return data;
    }

    var referrer = getCurrentItemReferrer();

    if (Array.isArray(data.items)) {
      data.items.forEach(function (item) {
        item.properties = item.properties || {};
        if (!item.properties[ITEM_REFERRER_PROP]) {
          item.properties[ITEM_REFERRER_PROP] = referrer;
        }
        rememberItemReferrer(item.id || item.variant_id, item.properties[ITEM_REFERRER_PROP]);
      });
      return data;
    }

    if (data.id) {
      data.properties = data.properties || {};
      if (!data.properties[ITEM_REFERRER_PROP]) {
        data.properties[ITEM_REFERRER_PROP] = referrer;
      }
      rememberItemReferrer(data.id, data.properties[ITEM_REFERRER_PROP]);
    }

    return data;
  }

  function injectItemReferrerIntoFormData(formData) {
    if (!(formData instanceof FormData)) {
      return formData;
    }

    var referrer = getCurrentItemReferrer();
    var propertyKey = 'properties[' + ITEM_REFERRER_PROP + ']';

    if (!formData.get(propertyKey)) {
      formData.set(propertyKey, referrer);
    }

    rememberItemReferrer(formData.get('id'), formData.get(propertyKey) || referrer);
    return formData;
  }

  function injectItemReferrerIntoAddBody(body, url) {
    if (!url || url.indexOf('cart/add') === -1) {
      return body;
    }

    if (body instanceof FormData) {
      return injectItemReferrerIntoFormData(body);
    }

    if (typeof body === 'string') {
      try {
        return JSON.stringify(injectItemReferrerIntoAddPayload(JSON.parse(body)));
      } catch (error) {
        return body;
      }
    }

    return body;
  }

  if (!window.__rbtItemReferrerFetchPatched) {
    window.__rbtItemReferrerFetchPatched = true;

    var originalFetch = window.fetch;
    window.fetch = function (input, init) {
      try {
        if (init && init.body != null) {
          var url = typeof input === 'string' ? input : (input && input.url) || '';
          if (url.indexOf('cart/add') !== -1) {
            init.body = injectItemReferrerIntoAddBody(init.body, url);
          }
        }
      } catch (error) {}

      return originalFetch.apply(this, arguments);
    };

    var originalOpen = XMLHttpRequest.prototype.open;
    var originalSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url) {
      this._rbtItemReferrerUrl = (url || '').toString();
      return originalOpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function (body) {
      try {
        if (this._rbtItemReferrerUrl && this._rbtItemReferrerUrl.indexOf('cart/add') !== -1) {
          body = injectItemReferrerIntoAddBody(body, this._rbtItemReferrerUrl);
        }
      } catch (error) {}

      return originalSend.call(this, body);
    };
  }

  function mapCheckoutCartItems(items) {
    return (items || []).map(function (item) {
      var itemReferrer =
        getLineItemProperty(item, ITEM_REFERRER_PROP) || getStoredItemReferrer(item.variant_id);

      return {
        product_id: item.product_id,
        variant_id: item.variant_id,
        title: item.title,
        quantity: item.quantity,
        price: item.price,
        line_price: item.final_line_price != null ? item.final_line_price : item.line_price,
        sku: item.sku || '',
        referrer: itemReferrer,
      };
    });
  }

  function fetchCheckoutCart() {
    return fetch('/cart.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Unable to read cart');
      }
      return response.json();
    });
  }

  function buildCheckoutInitiatedPayload(cart, button, checkoutIntentId) {
    var attribution = getCheckoutAttributionFields();

    return {
      event: 'checkout_initiated',
      session_id: getOrCreateCheckoutSessionId(),
      checkout_intent_id: checkoutIntentId,
      timestamp: new Date().toISOString(),
      source: getCheckoutInitiatedSource(button),
      shop: getShopDomain(),
      cart_token: cart.token || '',
      cart_value: cart.total_price || 0,
      currency: cart.currency || 'INR',
      item_count: cart.item_count || 0,
      items: mapCheckoutCartItems(cart.items),
      page_url: window.location.href,
      landing_page: attribution.landing_page,
      utm_source: attribution.utm_source,
      utm_medium: attribution.utm_medium,
      utm_campaign: attribution.utm_campaign,
      utm_content: attribution.utm_content,
      utm_term: attribution.utm_term,
      device_type: getCheckoutDeviceType(),
    };
  }

  function logCheckoutInitiated(payload) {
    if (!CHECKOUT_INIT_DEBUG) {
      return;
    }

    console.info('[Rabitat] checkout_initiated', payload);
    console.log(JSON.stringify(payload, null, 2));
    window.__rbtLastCheckoutInitiated = payload;
  }

  var CHECKOUT_INGEST_ENDPOINT = '/apps/funnel/checkout-initiated';

  /**
   * Send the event to the funnel API through the Shopify app proxy.
   *
   * Same-origin on purpose: Shopify signs the proxied request with the app's
   * own secret, so no token ships in theme source. A bearer token here would be
   * readable by every visitor, and anyone could forge checkout events into the
   * reporting this exists to produce.
   *
   * sendBeacon rather than fetch: the click hands off to GoKwik, and browsers
   * cancel in-flight fetch requests when the page unloads. A beacon is queued
   * by the browser and delivered regardless.
   *
   * Every path is wrapped and nothing is awaited. Losing an analytics event
   * costs a row in a table; delaying or blocking a checkout costs an order.
   */
  function sendCheckoutInitiated(payload) {
    try {
      var body = new Blob([JSON.stringify(payload)], { type: 'application/json' });
      if (navigator.sendBeacon && navigator.sendBeacon(CHECKOUT_INGEST_ENDPOINT, body)) {
        return;
      }
    } catch (error) {
      /* fall through to the keepalive fetch */
    }

    try {
      fetch(CHECKOUT_INGEST_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        keepalive: true,
        credentials: 'same-origin',
      }).catch(function () {});
    } catch (error) {
      /* never interfere with checkout */
    }
  }

  function rbtTrackCheckoutInitiated(button, checkoutIntentId) {
    if (!isCartGokwikCheckoutButton(button)) {
      return Promise.resolve(null);
    }

    if (button.dataset.rbtCheckoutInitiatedSent === '1') {
      return Promise.resolve(window.__rbtLastCheckoutInitiated || null);
    }

    button.dataset.rbtCheckoutInitiatedSent = '1';
    var intentId = checkoutIntentId || createCheckoutIntentId();

    return fetchCheckoutCart()
      .then(function (cart) {
        var payload = buildCheckoutInitiatedPayload(cart, button, intentId);
        logCheckoutInitiated(payload);
        sendCheckoutInitiated(payload);
        return payload;
      })
      .catch(function (error) {
        console.warn('[Rabitat] checkout_initiated payload failed', error);
        return null;
      })
      .finally(function () {
        window.setTimeout(function () {
          delete button.dataset.rbtCheckoutInitiatedSent;
        }, 3000);
      });
  }

  function isGokwikReady() {
    return typeof window.onBuyNowClick === 'function' || typeof window.onCheckoutClick === 'function';
  }

  function invokeGokwikCheckout(button) {
    if (button.id === 'gokwik-buy-now' || button.hasAttribute('data-gokwik-buy-now-trigger')) {
      return false;
    }

    if (button.closest('.gokwik-checkout') && typeof window.onCheckoutClick === 'function') {
      window.onCheckoutClick(button);
      return true;
    }

    return false;
  }

  function proceedWithCheckout(button) {
    function runCheckout() {
      if (button.id === 'gokwik-buy-now' || button.hasAttribute('data-gokwik-buy-now-trigger')) {
        return;
      }

      if (invokeGokwikCheckout(button)) {
        return;
      }

      button.dataset.rbtAcquisitionHandled = 'true';
      button.click();
    }

    if (isGokwikReady()) {
      runCheckout();
      return;
    }

    if (window.RabitatDeferredGokwik && typeof window.RabitatDeferredGokwik.load === 'function') {
      window.RabitatDeferredGokwik.load()
        .then(runCheckout)
        .catch(function () {
          runCheckout();
        });
      return;
    }

    runCheckout();
  }

  function setCheckoutButtonLoading(button, isLoading) {
    if (!button) return;

    var loader = button.querySelector('#btn-loader, .addloadr');

    if (isLoading) {
      if (button.dataset.rbtCheckoutLoading === 'true') return;
      button.dataset.rbtCheckoutLoading = 'true';
      button.setAttribute('aria-busy', 'true');
      button.classList.add('disabled', 'is-checkout-loading');
      button.disabled = true;
      if (loader) loader.style.display = 'flex';
      return;
    }

    if (button.dataset.rbtCheckoutLoading !== 'true') return;
    delete button.dataset.rbtCheckoutLoading;
    button.removeAttribute('aria-busy');
    button.classList.remove('disabled', 'is-checkout-loading');
    button.disabled = false;
    if (loader) loader.style.display = '';
  }

  function runPreCheckoutTasks(checkoutIntentId) {
    var acquisitionOpts = {
      timeoutMs: CHECKOUT_GA4_TIMEOUT_MS,
      force: true,
    };

    if (checkoutIntentId) {
      acquisitionOpts.extraAttributes = { checkout_intent_id: checkoutIntentId };
    }

    var tasks = [
      rbtAttachAcquisition(acquisitionOpts).catch(function () {
        return null;
      }),
    ];

    if (window.RabitatCart && typeof window.RabitatCart.sanitizeGiftLinesBeforeCheckout === 'function') {
      tasks.push(
        window.RabitatCart.sanitizeGiftLinesBeforeCheckout().catch(function () {
          return null;
        })
      );
    }

    return Promise.all(tasks);
  }

  function bindCheckoutCapture() {
    document.addEventListener(
      'click',
      function (event) {
        var button = event.target.closest(CHECKOUT_SELECTOR);
        if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') {
          return;
        }

        if (button.dataset.rbtAcquisitionHandled === 'true') {
          delete button.dataset.rbtAcquisitionHandled;
          return;
        }

        if (button.dataset.rbtCheckoutLoading === 'true') {
          event.preventDefault();
          event.stopPropagation();
          return;
        }

        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === 'function') {
          event.stopImmediatePropagation();
        }

        setCheckoutButtonLoading(button, true);

        var resetLoadingTimer = window.setTimeout(function () {
          setCheckoutButtonLoading(button, false);
        }, CHECKOUT_LOADING_RESET_MS);

        var checkoutIntentId = createCheckoutIntentId();

        runPreCheckoutTasks(checkoutIntentId)
          .then(function () {
            return rbtTrackCheckoutInitiated(button, checkoutIntentId);
          })
          .finally(function () {
            proceedWithCheckout(button);
            window.clearTimeout(resetLoadingTimer);
            window.setTimeout(function () {
              setCheckoutButtonLoading(button, false);
            }, 600);
          });
      },
      true
    );
  }

  window.rbtAttachAcquisition = rbtAttachAcquisition;
  window.rbtTrackCheckoutInitiated = rbtTrackCheckoutInitiated;

  captureOnLoad();
  bindCheckoutCapture();
})();